import List from "@/components/list";
import vue from "@/main";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };

  function deleteTopicLecture(item) {
    vue.$emit("deleteTopicLecture", item);
  }

  const auditStatusArr = ["审核中", "审核通过", "审核不通过"];
  const AuditStatus = ({ props: { vo } }) => {
    const auditStatusName = auditStatusArr[vo.row.auditStatus];
    return <div domPropsInnerHTML={auditStatusName}></div>;
  };
  const toDetail = listeners["toDetail"] || function () { };

  const Deal = ({ props: { vo } }) => {
    let icon = "icon-audit-detail";
    let explain = "审核详情";
    let dealConf = [];
    if (vo.row.myAuditStatus == 1) {
      // icon = "icon-audit";
      // explain = "审核";
      dealConf.push([
        "icon-audit",
        "审核",
        () => {
          toDetail(vo.row, '审核');
        },
        "topicLecture:queryDeclare"
      ]);
    } else {
      dealConf.push([
        "icon-audit-detail",
        "审核详情",
        () => {
          toDetail(vo.row, '审核详情');
        },
        "topicLecture:queryDeclare"
      ]);
    }
    // const dealConf = [
    //   [icon, explain, () => handleView(vo), ""]
    // ];

    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  function selectable(row, index) {
    if (row.myAuditStatus == 1) {
      return true
    }
    return false
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      selectable: selectable
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "90",
    }, {
      label: "工作单位",
      prop: "deptName",
      minWidth: "120",
      //showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "120",
      // showOverflowTooltip: true
    },
    {
      label: "讲座主题",
      prop: "lectureName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "授课老师",
      prop: "teacher",
      minWidth: "90",
      showOverflowTooltip: true
    },
    {
      label: "授课老师职务",
      prop: "teacherUnitPosition",
      minWidth: "120"
    },
    {
      label: "讲座时间",
      prop: "trainTimeStr",
      minWidth: "120",
    },
    {
      label: "学时",
      prop: "lectureHours",
      minWidth: "80",
    },
    {
      label: "我的审核状态",
      prop: "myAuditStatusStr",
      width: "100",
    },
    {
      label: "申报审核状态",
      prop: "auditStatusStr",
      width: "100",
      // render: vo => <AuditStatus vo={vo} />
    },
    {
      label: "操作",
      fixed: "right",
      with: "40",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};
export default Table;
